
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'

// module components
import PretensionFiles from '@/modules/PretensionsModule/components/PretensionFiles/index.vue'

// composable
import { useRoute } from 'vue-router'

// types
import { PretensionT } from '@/core/types/pretensions.types'

// realisations
import { pretensions } from '@/core/realisations/pretensions.realisation'

import { formatDateFromBackend, formatDateWithTimeFromBackend } from '@/common/helpers/formatDate'

export default defineComponent({
    components: {
        'page-title': PageTitle,
        'the-button': TheButton,
        'failed-fetch': FailedFetch,
        loader: Loader,
        cheap: Cheap,
        PretensionFiles,
    },
    setup() {
        const route = useRoute()
        const id = Number(route.params.id)

        const state = reactive({
            is_loading: false,
            is_failed: false,
            //
            pretension: null as PretensionT | null,
        })

        const loadPretension = async () => {
            try {
                state.is_loading = true

                const response = await pretensions.getPretension(id)
                state.pretension = response.data

                state.is_failed = false
            } catch (error) {
                console.error(error)
                state.is_failed = true
            } finally {
                state.is_loading = false
            }
        }

        const getFiles = (files_type: string) => {
            if (state.pretension && state.pretension.files) {
                if (files_type === 'files' && state.pretension.files) {
                    return state.pretension.files.data
                } else if (
                    files_type === 'quality_control_file' &&
                    state.pretension.quality_control_file
                ) {
                    return state.pretension.quality_control_file.data
                } else if (files_type === 'final_file' && state.pretension.final_file) {
                    return state.pretension.final_file.data
                }
            }

            return []
        }

        onBeforeMount(() => {
            loadPretension()
        })

        return {
            state,
            loadPretension,
            //
            getFiles,
            formatDateFromBackend,
            formatDateWithTimeFromBackend
        }
    },
})
